// Gedeelde formatters. Why: eerder stond dezelfde Intl-aanroep in vier
// componenten — één plek voorkomt dat bedragen per scherm anders ogen.

export function formatEuros(cents) {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 2
  }).format((cents || 0) / 100);
}

export function centsToInput(cents) {
  return cents != null ? (cents / 100).toFixed(2) : '';
}

// Why: Number.parseFloat stopt bij het eerste teken dat het niet kent, en dat
// is bij Nederlandse invoer de komma. "500,50" werd zo 500 en "1.234,56" werd
// 1.234, oftewel één euro drieëntwintig. Zonder foutmelding, en het bedrag komt
// op een factuur.
//
// De regel: staat er een komma in, dan is dat het decimaalteken en zijn punten
// duizendtallen. Staat er alleen een punt, dan is dat het decimaalteken.
export function inputToCents(value) {
  if (value === '' || value == null) return null;
  const cleaned = String(value).replace(/[\s\u00a0€]/g, '');
  const normalised = cleaned.includes(',')
    ? cleaned.replace(/\./g, '').replace(',', '.')
    : cleaned;
  if (!/^-?\d*\.?\d*$/.test(normalised) || normalised === '' || normalised === '.') return null;
  const parsed = Number(normalised);
  return Number.isFinite(parsed) ? Math.round(parsed * 100) : null;
}

export function formatDate(iso) {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' })
    .format(new Date(iso));
}

export function formatRelative(iso) {
  if (!iso) return 'nooit';
  const ageSec = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (ageSec < 5) return 'zojuist';
  if (ageSec < 60) return `${ageSec}s geleden`;
  const min = Math.round(ageSec / 60);
  if (min < 60) return `${min}m geleden`;
  const hours = Math.round(min / 60);
  if (hours < 24) return `${hours}u geleden`;
  return `${Math.round(hours / 24)}d geleden`;
}

export const INTERVAL_LABEL = { month: 'per maand', year: 'per jaar' };
